module.exports = __webpack_public_path__ + "img/160x130.b1ef4f81.png";